import { Col, Row, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';

import { withRouteChange } from '../services/APM';
import styles from './NotFound.module.css';

const NotFound = () => {
  return (
    <main className={styles.main}>
      <Helmet>
        <title>Ops! Página não encontrada | Recrutamento e Seleção</title>
      </Helmet>
      <p className={styles.background_number_error}>404</p>
      <Row align="middle" justify="center" className={styles.row}>
        <Col span={16} className={styles.column}>
          <Typography.Title className={styles.title} level={2}>
            Ops! Página não encontrada
          </Typography.Title>
          <p>Nos desculpe! A página que você tentou acessar está indisponível ou não existe.</p>
          <p>Lembre-se de verificar o link de acesso.</p>
        </Col>
      </Row>
    </main>
  );
};

export default withRouteChange()(NotFound);
